import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Patient } from '../models/pateint';
import { Observable } from 'rxjs';
import { inrDTO } from '../models/inrDTO';
import { InrPatientProfile } from '../models/inr-patient-profile.model';
import { API_ROUTES, BASE_URL } from '../../core/constants/api.const';
import { ApiRoutesModel } from '../../core/models/apiRoutesModel';

@Injectable({
  providedIn: 'root',
})
export class INRService {
  constructor(
    private http: HttpClient,
    @Inject(BASE_URL) private readonly baseURL: string,
    @Inject(API_ROUTES) private readonly apiRoutes: ApiRoutesModel) { }

  getPatientList(filter?: any): Observable<any> {
    let url = `${this.baseURL}/${this.apiRoutes.inr.patientsWithInr}`;
    if (filter) {
      var filterStr = this.buildString(filter);
      url += `?${filterStr}`;
    }
    return this.http.get<any>(url)
  }

  buildString(filter: any): string {
    // Extract properties from filter
    var { first, rows, sortField, sortOrder, filters } = filter;
    var page: number = 0;
    // Check if required properties exist
    if (first && rows) {
      // Calculate page number
      page = first / rows;
    }
    var sortDirection = 'desc';
    // Determine sort directory
    if (sortOrder) {
      sortDirection = sortOrder > 0 ? 'asc' : 'desc';
    }
    if (sortField == null) {
      sortField = 'lastInrValue';
    } else if (sortField === 'fullName') {
      sortField = 'name';
    }
    var url = `page=${page}&size=${rows}&sortBy=${sortField}&sortDirection=${sortDirection}`;

    var filterURL = ''
    for (const key in filters) {
      if (filters.hasOwnProperty(key)) {
        if (filters[key]) {
          let value = filters[key].value;
          if (value !== null && value !== '') {
            if (value instanceof Date) {
              value = new Date(value.getTime() - (value.getTimezoneOffset() * 60000)).toISOString().split('T')[0];
            }
            const paramKey = key === 'fullName' ? 'name' : key;
            filterURL += `&${paramKey}=${encodeURIComponent(value)}`;
          }
        }
      }
    }
    url += filterURL;
    return url;
  }

  getPatientById(id: string): Observable<InrPatientProfile> {
    let url = `${this.baseURL}/${this.apiRoutes.inr.patientsWithInr}/${id}`;
    return this.http.get<InrPatientProfile>(url)
  }

  updateInrStatus(patient: Patient): Observable<inrDTO> {
    let url = `${this.baseURL}/${this.apiRoutes.inr.updateStatus}/${patient.id}/${patient.inr.inrStatus}`;
    return this.http.patch<inrDTO>(url, patient)
  }

  downloadDocument(nationalId: string, inrRequestId: number, fileName: string): Observable<Blob> {
    let url = `${this.baseURL}/${this.apiRoutes.inr.requestDocuments}?national-id=${nationalId}&inr-request-id=${inrRequestId}&file-name=${fileName}`;
    return this.http.get(url, { responseType: 'blob' });
  }

  submitInrResponse(inrRequestId: number, responsePayload: any): Observable<any> {
    const url = `${this.baseURL}/${this.apiRoutes.inr.submitResponse}/${inrRequestId}/response`;
    return this.http.post(url, responsePayload);
  }

  assignPatientToINR(payload: any): Observable<any> {
    const url = `${this.baseURL}/${this.apiRoutes.inr.assign}`;
    return this.http.post(url, payload);
  }
}
